module.exports = __webpack_public_path__ + "static/media/playstore.71bb620d.svg";